import React, { forwardRef } from "react";

import styled from "styled-components";

//assets

//styles
import typographySizes from "styles/typographySizes.js";
import mediaQuery from "styles/mediaQuery.js";

//components
import TextWithLineBreaks from "components/global/typography/TextWithLineBreaks.js";

const BodyParagraph = styled.p`
  font-size: ${typographySizes.text.tekstSize1.size.desktop}rem;
  line-height: ${typographySizes.text.tekstSize1.lineHeight};
  @media (max-width: ${mediaQuery.tablet}) {
    font-size: ${typographySizes.text.tekstSize2.size.mobile}rem;
  }
`;

const Body = forwardRef(({ children, className }, ref) => {
  return (
    <BodyParagraph ref={ref} className={className}>
      <TextWithLineBreaks text={children} />
    </BodyParagraph>
  );
});

export default Body;
